<app-modal [isOpen]="isOpen()" (closeModal)="isOpenChange.emit()">
  <ng-container header>Item Details</ng-container>

  <div body>
    <div class="flex justify-center">
      <app-item-image [item]="item()" width="150" height="150"/>
    </div>

    <span class="text-lg text-gray-700 dark:text-gray-400 flex items-center gap-2">
      {{item().model}}

      <div class="flex gap-1">
        @if (editItemVisible()) {
          <app-link class="item-edit" (click)="eventService.emit('edit-item', {item: item()})" [disabled]="editItemDisabled()" [title]="access.getTitle('edit_item', 'Edit Item')">
            <app-icons icon="file-pen" svgClass=""/>
          </app-link>
        }

        @if (itemHistoryVisible()) {
          <app-link class="item-history" (click)="eventService.emit('open-item-history', {item: item()})" [disabled]="itemHistoryDisabled()" [title]="access.getTitle('view_item_history', 'Open Item History')">
            <app-icons icon="clock-rotate-left" svgClass=""/>
          </app-link>
        }
      </div>
    </span>

    <ul class="mt-2 space-y-2  list-inside text-sm">
      <li class="flex justify-between">
        <span>Brand</span>
        <span class="font-semibold text-gray-700 dark:text-gray-400">{{ item().brand }}</span>
      </li>

      <li class="flex justify-between">
        <span>Style</span>
        <span class="font-semibold text-gray-700 dark:text-gray-400">{{ item().model }}</span>
      </li>

      <li class="flex justify-between">
        <span>Item Number</span>
        <span class="font-semibold text-gray-700 dark:text-gray-400">{{ item().item_number }}</span>
      </li>

      <li class="flex justify-between">
        <span>Size, Load, Speed</span>
        <span class="font-semibold text-gray-700 dark:text-gray-400">{{ item().size }} <span class="text-secondary">{{ getFeatureString(item()) }}</span></span>
      </li>

      @for (feature of getFeatures(item()); track $index) {
        <li class="flex justify-between">
          <span>{{ feature.name | titlecase }}</span>
          <span class="font-semibold text-gray-700 dark:text-gray-400">{{ feature.value }}</span>
        </li>
      }
    </ul>
  </div>

  <div footer class="flex justify-center gap-2">
    <ng-content select="[actions]"/>
  </div>
</app-modal>
